<style scoped>
.dropdown-menu::after,
.dropdown-menu::before {
  content: none;
}
</style>

<template>
  <td>
    <div v-if="!this.user.deleted_at && !isSelf" class="btn-group">
      <button
        @click="toggleUserDisabled()"
        class="btn"
        :class="[isDisabled ? '' : 'btn-danger']"
        :title="userDisabledText"
      >
        <i class="fas fa-ban"></i>
      </button>
      <button
        @click="deleteUser()"
        class="btn btn-danger"
        title="Moderator löschen"
      >
        <i class="fas fa-trash-alt"></i>
      </button>
    </div>
  </td>
</template>

<script lang="babel">

export default {
    props: ["model", "tableId", "index"],
    data() {
      return {
        working: false,
        deleting: false,
        disableMessage: "",
      };
    },
    computed: {
      isSelf() {
        return this.$store.getters["user/me"].id === this.id;
      },
      id() {
        return this.model.user_id ? this.model.user_id : this.model.id;
      },
      isDisabled() {
        return Boolean(this.user.disabled_at);
      },
      userDisabledText() {
        return this.isDisabled ? "Moderator entsperren" : "Moderator sperren";
      },
      user() {
        return this.model.user ? this.model.user : this.model;
      },
      attributePath() {
        return this.model.user ? 'user.disabled_at' : 'disabled_at';
      }
    },
    methods: {
    toggleUserDisabled() {

      if (this.isDisabled) {
        this.enableUser();
      } else {
        this.disableUser();
      }
    },
    disableUser() {
      if (this.isDisabled) {
        return;
      }
      this.$http
        .post("/api/v1/userDisabled", {
          user_id: this.id,
          message: this.disableMessage.length === 0 ? null : this.disableMessage
        })
        .then(({ data }) => {
          this.$store.commit("table/updateModel", {
            tableId: this.tableId,
            modelId: this.id,
            attributePath: this.attributePath,
            data: data
          });

          this.$notify({
            title: `${this.user.name} wurde gesperrt`,
            type: "success"
          });
        })
        .finally(() => {
          this.disableModalActions = false;
          this.$emit("table-update");
        });
    },
    enableUser() {
      if (!this.isDisabled) {
        return;
      }
      this.$http
        .delete(`/api/v1/userDisabled/${this.id}`)
        .then(() => {
          this.$store.commit("table/updateModel", {
            tableId: this.tableId,
            modelId: this.id,
            attributePath: this.attributePath,
            data: undefined
          });
          this.$notify({
            title: `${this.user.name} wurde entsperrt`,
            type: "success"
          });
        })
        .finally(() => {
          this.$emit("table-update");
        });
    },
    deleteUser() {
      let confirmed = confirm(
        `Willst du wirklich "${this.user.name}" löschen?`
      );
      if (!confirmed) {
        return;
      }
      this.deleting = true;
      this.$http
        .delete("/api/v1/moderator/" + this.id,{
          user_id: this.id
        })
        .then(() => {
          this.$notify({
            title: `${this.user.name} wurde gelöscht`,
            type: "success"
          });
        })
        .finally(() => {
          this.$emit("table-update", { count: true });
          this.deleting = false;
        });
    },
  },
};
</script>
